// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { SignUpResult } from '@innolab-trader/tradovate-types/src/enums/signUpResult'

export interface SignUpWithEmail {
  name: string
  email: string
  password: string
  organization?: string
  tac?: string
  h: string
  locale?: string
  originOrganization?: string
}

export interface SignUpResponse {
  errorText?: string
  errorCode: SignUpResult
  userId?: number
  emailVerified: boolean
  promoText?: string
}

/**
 * Validate SignUpWithEmail request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateSignUpWithEmail(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateSignUpWithEmail(request: SignUpWithEmail): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.name === undefined || req.name === null) {
    errors.push({
      field: 'name',
      code: 'required',
      message: 'name is required'
    })
  }
  if (typeof req.name === 'string' && req.name.length > 64) {
    errors.push({
      field: 'name',
      code: 'too_long',
      message: 'name must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.name === 'string' && req.name.trim() === '') {
    errors.push({
      field: 'name',
      code: 'required',
      message: 'name cannot be empty'
    })
  }

  if (req.email === undefined || req.email === null) {
    errors.push({
      field: 'email',
      code: 'required',
      message: 'email is required'
    })
  }
  if (typeof req.email === 'string' && req.email.length > 64) {
    errors.push({
      field: 'email',
      code: 'too_long',
      message: 'email must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.email === 'string' && req.email.trim() === '') {
    errors.push({
      field: 'email',
      code: 'required',
      message: 'email cannot be empty'
    })
  }

  if (req.password === undefined || req.password === null) {
    errors.push({
      field: 'password',
      code: 'required',
      message: 'password is required'
    })
  }
  if (typeof req.password === 'string' && req.password.length > 64) {
    errors.push({
      field: 'password',
      code: 'too_long',
      message: 'password must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.password === 'string' && req.password.trim() === '') {
    errors.push({
      field: 'password',
      code: 'required',
      message: 'password cannot be empty'
    })
  }

  if (typeof req.organization === 'string' && req.organization.length > 64) {
    errors.push({
      field: 'organization',
      code: 'too_long',
      message: 'organization must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.tac === 'string' && req.tac.length > 64) {
    errors.push({
      field: 'tac',
      code: 'too_long',
      message: 'tac must not exceed 64 characters',
      argument: '64'
    })
  }

  if (req.h === undefined || req.h === null) {
    errors.push({
      field: 'h',
      code: 'required',
      message: 'h is required'
    })
  }
  if (typeof req.h === 'string' && req.h.length > 8192) {
    errors.push({
      field: 'h',
      code: 'too_long',
      message: 'h must not exceed 8192 characters',
      argument: '8192'
    })
  }
  if (typeof req.h === 'string' && req.h.trim() === '') {
    errors.push({
      field: 'h',
      code: 'required',
      message: 'h cannot be empty'
    })
  }

  if (typeof req.locale === 'string' && req.locale.length > 64) {
    errors.push({
      field: 'locale',
      code: 'too_long',
      message: 'locale must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.originOrganization === 'string' && req.originOrganization.length > 64) {
    errors.push({
      field: 'originOrganization',
      code: 'too_long',
      message: 'originOrganization must not exceed 64 characters',
      argument: '64'
    })
  }

  return errors
}

export const signUpWithEmail = postEndpoint<SignUpWithEmail, SignUpResponse>('/auth/signUpWithEmail')
